import { Injectable } from '@angular/core';
import { ApiService } from '@fg-services/api/api.service';
import { BehaviorSubject, Subscription } from 'rxjs';

/**
 * Open incident report count per event, shown next to "Incident Reports" in the side menu.
 * The Incident Reports page refreshes it after a report changes status.
 */
@Injectable({
  providedIn: 'root'
})
export class IncidentReportCountService {
  private counts = new BehaviorSubject<Record<string, number>>({});
  private requests = new Map<string, Subscription>();

  constructor(private api: ApiService) {}

  getCountsAsObservable() {
    return this.counts.asObservable();
  }

  has(conventionId: string) {
    return this.requests.has(conventionId) || this.counts.value[conventionId] !== undefined;
  }

  refresh(conventionId: string) {
    this.requests.get(conventionId)?.unsubscribe();
    this.requests.set(
      conventionId,
      this.api.incidentReports.getOpenCount(conventionId).subscribe(
        ({ pending = 0, in_review = 0, total }) => {
          this.counts.next({
            ...this.counts.value,
            [conventionId]: total ?? pending + in_review
          });
        },
        // the count is optional, so a failed request just leaves it out of the menu
        () => this.requests.delete(conventionId)
      )
    );
  }
}
